import Notification from './models'

export default Notification
